import { SlideNotifier } from "./slideNotifier.model";
import { Announcer } from "./announcer.model";
import { Quote } from "./qoute.model";
import { SlideShowModel } from "./slideshow.model";

export class Ceremony {
    slideNotifier: SlideNotifier;
    announcer: Announcer;
    quote: Quote;
    slideshow: SlideShowModel;
}


// WEBPACK FOOTER //
// ./src/app/models/ceremony.model.ts